module.exports = __webpack_public_path__ + "media/components/country-flag/static/th-21107194f358b3ddaaa10e933239fc11.svg";